export default "__VITE_ASSET__BB_JRjOb__";